window.CollabSeason.ready.then(()=>{
/* My account: membership status from the page, collabs from the member store already on every page. */
(() => {
  const root = document.getElementById('ma');
  if (!root) return;
  const lang = (document.documentElement.lang || 'en') === 'en' ? 'en-GB' : document.documentElement.lang;
  const words = JSON.parse(document.querySelector('[data-ma-i18n]')?.textContent || '{}');
  for (const key of Object.keys(words)) if (typeof words[key] === 'string') words[key] = window.CollabSeason.decode(words[key]);
  const fill = (line, key, value) => String(line || '').replace(new RegExp('\\{\\{\\s*' + key + '\\s*\\}\\}', 'g'), value);
  const day = value => {
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? '' : date.toLocaleDateString(lang, { day: 'numeric', month: 'long', year: 'numeric' });
  };
  const shortDay = value => {
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? '' : date.toLocaleDateString(lang, { day: 'numeric', month: 'short' });
  };
  const money = (amount, currency) => {
    if (!Number.isFinite(Number(amount)) || !/^[A-Z]{3}$/.test(currency || '')) return '';
    return new Intl.NumberFormat(lang, { style: 'currency', currency }).format(Number(amount));
  };

  // Open collab count for the join and sign-in stickers.
  const C = window.CollabSeason;
  for (const sticker of root.querySelectorAll('[data-ma-count]')) {
    const count = C?.deals?.length ?? 0;
    if (!count) continue;
    sticker.querySelector('b').textContent = count;
    sticker.dataset.count = '';
    sticker.hidden = false;
  }

  // Jump links follow the section in view.
  const jump = root.querySelector('.ma-jump');
  if (jump && 'IntersectionObserver' in window) {
    const links = [...jump.querySelectorAll('a')];
    const seen = new Map();
    const pick = () => {
      const current = links.find(a => seen.get(a.hash.slice(1))) ?? links[0];
      links.forEach(a => a.setAttribute('aria-current', String(a === current)));
    };
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => seen.set(entry.target.id, entry.isIntersecting));
      pick();
    }, { rootMargin: '-35% 0px -55% 0px' });
    links.forEach(a => { const target = document.getElementById(a.hash.slice(1)); if (target) observer.observe(target); });
  }

  // Delete my account: the open box is the confirm step. Keep closes it; after a send or an error the page comes back here.
  const del = root.querySelector('.ma-del');
  if (del) {
    const box = del.querySelector('details');
    del.querySelector('[data-ma-del-keep]')?.addEventListener('click', () => { box.open = false; box.querySelector('summary').focus(); });
    if (del.querySelector('.ma-del-done, .ma-del-err')) del.scrollIntoView({ block: 'center' });
  }

  const feedback = root.querySelector('[data-ma-feedback]');
  const message = (node,text) => {if(!node)return;node.textContent=text;node.hidden=!text;if(text&&[words.error,words.noteError,words.partial,words.stale,words.switchUnavailable,words.noMembership,words.noPayments].includes(text)){const link=document.createElement('a');link.href=root.dataset.maContact;link.textContent=words.contact;node.append(' ',link);}};
  const announce = text => message(feedback,text);
  const requestJSON = async(url,method='GET',body) => {
    const response=await fetch(url,{method,credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json',...(body?{'Content-Type':'application/json'}:{})},...(body?{body:JSON.stringify(body)}:{}),signal:AbortSignal.timeout(15000)});
    const text=await response.text();let data=null;
    if(text){try{data=JSON.parse(text);}catch{throw Error('unavailable');}}
    if(!response.ok || Number(data?.status)>=400 || data?.success===false || data?.error || data?.errors?.length || data?.userErrors?.length)throw Error('unavailable');
    return data;
  };
  const working = async(container,run) => {
    const buttons=[...container.querySelectorAll('button')],disabled=buttons.map(b=>b.disabled);
    container.setAttribute('aria-busy','true');buttons.forEach(b=>b.disabled=true);
    try{return await run();}finally{container.setAttribute('aria-busy','false');buttons.forEach((b,i)=>b.disabled=disabled[i]);}
  };
  const closeEditor = form => {
    form.hidden=true;const button=root.querySelector('[data-ma-edit-open="'+form.dataset.maEdit+'"]');
    button?.setAttribute('aria-expanded','false');button?.focus();
  };
  for(const button of root.querySelectorAll('[data-ma-edit-open]'))button.addEventListener('click',()=>{
    const form=root.querySelector('[data-ma-edit="'+button.dataset.maEditOpen+'"]');
    for(const other of root.querySelectorAll('[data-ma-edit]'))if(other!==form){other.hidden=true;root.querySelector('[data-ma-edit-open="'+other.dataset.maEdit+'"]')?.setAttribute('aria-expanded','false');}
    form.hidden=false;button.setAttribute('aria-expanded','true');form.querySelector('input')?.focus();announce('');
  });
  for(const form of root.querySelectorAll('[data-ma-edit]')){
    form.querySelector('[data-ma-edit-keep]')?.addEventListener('click',()=>{form.reset();closeEditor(form);});
    form.addEventListener('submit',async event=>{
      event.preventDefault();if(form.getAttribute('aria-busy')==='true'||!form.reportValidity())return;
      const action=form.dataset.maEdit;
      try{await working(form,async()=>{
        const data=await requestJSON(root.dataset.maAccountApi+'/'+action+'?locale='+encodeURIComponent(document.documentElement.lang),'POST',Object.fromEntries(new FormData(form)));
        if(action==='name'){
          root.querySelector('[data-ma-name]').textContent=[data.firstName,data.lastName].filter(Boolean).join(' ')||words.nameBlank;
          const heading=root.querySelector('[data-ma-greeting]');if(heading)heading.textContent=data.firstName?.trim()?fill(words.hello,'name',data.firstName.trim()):words.helloBlank;
          for(const key of ['firstName','lastName']){form.elements[key].value=data[key]||'';form.elements[key].defaultValue=data[key]||'';}
        }else{
          for(const node of root.querySelectorAll('[data-ma-email]'))node.textContent=data.email;
          form.elements.email.value=data.email;form.elements.email.defaultValue=data.email;
        }
        closeEditor(form);announce(words.saved);
      });}catch{announce(words.error);}
    });
  }
  const marketing=root.querySelector('[data-ma-marketing]');
  marketing?.addEventListener('click',async()=>{
    if(marketing.disabled)return;marketing.disabled=true;
    try{const data=await requestJSON(root.dataset.maAccountApi+'/marketing?locale='+encodeURIComponent(document.documentElement.lang),'POST',{subscribed:marketing.getAttribute('aria-checked')!=='true'});
      marketing.dataset.on=String(data.subscribed);marketing.setAttribute('aria-checked',String(data.subscribed));marketing.querySelector('span').textContent=data.subscribed?words.on:words.off;announce(words.saved);
    }catch{announce(words.error);}finally{marketing.disabled=false;}
  });
  for(const time of root.querySelectorAll('[data-ma-date]'))time.textContent=day(time.dataset.maDate);
  for(const button of root.querySelectorAll('[data-ma-receipt-open]'))button.addEventListener('click',()=>{
    const receipt=document.getElementById(button.getAttribute('aria-controls'));receipt.hidden=!receipt.hidden;button.setAttribute('aria-expanded',String(!receipt.hidden));
  });

  // Membership: the page shows status from the member tag. Card, plan and cancel links go to the membership portal or contact page.
  const panel = root.querySelector('[data-ma-membership]');
  if(panel){
    const payments=panel.querySelector('[data-ma-action="payments"]');payments.addEventListener('click',()=>{const box=panel.querySelector('#maPayments');box.hidden=!box.hidden;payments.setAttribute('aria-expanded',String(!box.hidden));payments.querySelector('.ma-go').textContent=box.hidden?words.view:words.close;});
    if(new URLSearchParams(location.search).has('page'))payments.click();
  }

  // Profile row: the same 7 items the Profile page counts. Photo, name and address come from the page; the rest from the member Worker.
  const profileRow = root.querySelector('[data-ma-profile]');
  if (profileRow) {
    const have = [...(profileRow.dataset.have || '')].filter(c => c === '1').length;
    requestJSON(profileRow.dataset.api + '/profile').then(p => {
      const done = have + [p.country, p.socials?.length, p.niches?.length, p.collabTypes?.length].filter(Boolean).length;
      const state = profileRow.querySelector('[data-ma-profile-state]');
      state.toggleAttribute('data-on', done === 7);
      state.innerHTML = done === 7 ? '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M3.5 8.3l3 3 6-6.3" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>' : '';
      state.append(done === 7 ? profileRow.dataset.all : fill(profileRow.dataset.label, 'done', done));
      state.hidden = false;
    }).catch(() => {});
  }

  // My collabs: the same applications and saves the Members Hub shows.
  const collabs = root.querySelector('[data-ma-collabs]');
  if (collabs && C && !collabs.hasAttribute('data-free-saves')) {
    const appsList = collabs.querySelector('[data-ma-apps]');
    const savedList = collabs.querySelector('[data-ma-saved]');
    const labels = { forward: C.text('sa48062223f19'), selected: C.text('s57fd7a0cf33f'), applied: C.text('sefb5bd92d76a'), opened: C.text('s1bb19e17dec8'), not: C.text('s6f3efa36d8ec') };
    const hero = root.querySelector('.ma-pic img');
    const reserved = hero ? [C.photoSource(hero.src)].filter(Boolean) : [];
    const row = (d, chip, index) => '<li><a class="ma-row" href="' + C.escape(d.url) + '" style="animation-delay:' + (index * 0.06) + 's"><span class="ma-thumb" style="--c:' + C.escape(d.c) + '"><img src="' + C.escape(d.cut) + '" alt=""></span><span class="ma-row-t">' + chip + '<b>' + C.escape(d.name || d.hint) + '</b><small>' + C.escape(d.pay || d.line) + '</small></span></a></li>';
    // Full lists in pages, as the Hub box did, so no photo repeats on one screen.
    const size = C.photoCatalog?.hub_page_size || 6, pages = { apps: 0, saved: 0 };
    const pager = (list, key) => {
      const nav = document.createElement('nav'); nav.className = 'photo-pagination'; nav.hidden = true;
      nav.setAttribute('aria-label', list.closest('div')?.querySelector('h3')?.textContent || '');
      const previous = document.createElement('button'), next = document.createElement('button'), count = document.createElement('span');
      for (const button of [previous, next]) { button.type = 'button'; button.className = 'btn'; }
      previous.textContent = C.text('sa57b08a480b8'); next.textContent = C.text('s1ff57a29d7c9'); count.className = 'mono'; count.setAttribute('aria-live', 'polite');
      nav.append(previous, count, next); list.after(nav);
      previous.addEventListener('click', () => { pages[key]--; render(); });
      next.addEventListener('click', () => { pages[key]++; render(); });
      return (total) => {
        const last = Math.max(0, Math.ceil(total / size) - 1); pages[key] = Math.max(0, Math.min(pages[key], last));
        nav.hidden = total <= size; previous.disabled = pages[key] === 0; next.disabled = pages[key] === last; count.textContent = (pages[key] + 1) + ' / ' + (last + 1);
        return pages[key] * size;
      };
    };
    let appsPager, savedPager;
    const render = () => {
      appsPager ??= pager(appsList, 'apps'); savedPager ??= pager(savedList, 'saved');
      const state = window.csStore.get();
      const byId = new Map(C.deals.map(d => [d.id, d]));
      const apps = state.apps.filter(a => byId.has(a.id)).sort((a, b) => b.timestamp - a.timestamp);
      const saved = state.saved.filter(id => byId.has(id));
      const count = st => apps.filter(a => a.st === st).length;
      collabs.querySelector('[data-ma-n="forward"]').textContent = count('forward');
      collabs.querySelector('[data-ma-n="selected"]').textContent = count('selected');
      const allSaved = saved.filter(id => !apps.some(a => a.id === id && a.st !== 'opened')), appsFrom = appsPager(apps.length), savedFrom = savedPager(allSaved.length);
      collabs.querySelector('[data-ma-n="saved"]').textContent = allSaved.length;
      const shownApps = apps.slice(appsFrom, appsFrom + size), shownSaved = allSaved.slice(savedFrom, savedFrom + size);
      const pictures = new Map(C.distinctPhotos([...shownApps.map(a => byId.get(a.id)), ...shownSaved.map(id => byId.get(id))], reserved).map(d => [d.id, d]));
      appsList.innerHTML = shownApps.length ? shownApps.map((a, i) => row(pictures.get(a.id) ?? byId.get(a.id), '<span class="ma-chip" data-st="' + C.escape(a.st) + '">' + C.escape(labels[a.st] ?? '') + ' <time>' + C.escape(shortDay(a.timestamp * 1000)) + '</time></span>', i)).join('') : '<li class="ma-empty">' + C.escape(words.appsEmpty) + '</li>';
      savedList.innerHTML = shownSaved.length ? shownSaved.map((id, i) => { const d = pictures.get(id) ?? byId.get(id); return row(d, '<span class="ma-chip">' + C.escape(d.line) + '</span>', i); }).join('') : '<li class="ma-empty">' + C.escape(words.savedEmpty) + '</li>';
      collabs.querySelector('.ma-lists').setAttribute('aria-busy', 'false');
    };
    C.ready.then(() => {
      if (!C.privateReady) {
        collabs.querySelector('[data-ma-collabs-error]').hidden = false;
        appsList.innerHTML = ''; savedList.innerHTML = '';
        collabs.querySelector('.ma-lists').setAttribute('aria-busy', 'false');
        return;
      }
      render();
      document.addEventListener('cs:store', render);
    });
  }
  if (collabs && C && collabs.hasAttribute('data-free-saves')) {
    const list=collabs.querySelector('[data-ma-saved]'),join=collabs.dataset.join;
    const nav=document.createElement('nav'),previous=document.createElement('button'),next=document.createElement('button'),count=document.createElement('span');let page=0;
    nav.className='photo-pagination';nav.setAttribute('aria-label',C.saveCopy.saved || C.text('saved'));nav.hidden=true;count.className='mono';count.setAttribute('aria-live','polite');
    for(const button of [previous,next]){button.type='button';button.className='btn';}previous.textContent=C.text('sa57b08a480b8');next.textContent=C.text('s1ff57a29d7c9');nav.append(previous,count,next);list.after(nav);
    previous.addEventListener('click',()=>{page--;render();});next.addEventListener('click',()=>{page++;render();});

    const render=()=>{
      const byId=new Map(C.deals.map(d=>[d.id,d])),saved=window.csStore.get().saved.filter(id=>byId.has(id));
      collabs.querySelector('[data-ma-n="saved"]').textContent=saved.length;
      const last=Math.max(0,Math.ceil(saved.length/6)-1);page=Math.max(0,Math.min(page,last));nav.hidden=saved.length<=6;previous.disabled=page===0;next.disabled=page===last;count.textContent=(page+1)+' / '+(last+1);
      const pictures=C.distinctPhotos(saved.slice(page*6,page*6+6).map(id=>byId.get(id)));
      list.innerHTML=saved.length?pictures.map(d=>'<li class="ma-row fs-row"><span class="ma-thumb" style="--c:'+C.escape(d.c)+'"><img src="'+C.escape(d.cut)+'" alt=""></span><span class="ma-row-t"><b>'+C.escape(C.saveCopy[d.cat+'_collab'] || d.hint)+'</b><small>'+C.escape(d.line)+'</small><a href="'+C.escape(join)+'">'+C.escape(C.saveCopy.join_apply)+'</a></span><button class="fs-remove" type="button" data-free-remove="'+C.escape(d.id)+'" aria-label="'+C.escape(C.saveCopy.remove)+'"><svg viewBox="0 0 16 18" aria-hidden="true"><path d="M2.5 1.5h11v15l-5.5-3.9-5.5 3.9z" fill="none" stroke="currentColor" stroke-width="1.5"/></svg></button></li>').join(''):'<li class="ma-empty fs-empty"><h3>'+C.escape(C.saveCopy.empty_title)+'</h3><p>'+C.escape(C.saveCopy.empty_note)+'</p><a class="btn" href="'+C.escape(C.routes.hub)+'">'+C.escape(C.saveCopy.browse)+'</a></li>';
      collabs.querySelector('.ma-lists').setAttribute('aria-busy','false');
    };
    collabs.addEventListener('click',async event=>{const button=event.target.closest('[data-free-remove]');if(!button)return;button.disabled=true;try{await window.csStore.toggle(button.dataset.freeRemove);window.csToast(C.text('removedNotice'));}catch{button.disabled=false;window.csToast(C.saveCopy.unavailable);}});
    C.ready.then(()=>{if(!C.savedReady){list.innerHTML='';collabs.querySelector('[data-ma-collabs-error]').hidden=false;collabs.querySelector('.ma-lists').setAttribute('aria-busy','false');return;}render();document.addEventListener('cs:store',render);});
  }
})();

});
